// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useToast } from '../../../components/ToastProvider'
import DialogDP from '../../../components/acc/DialogDP'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State
    const [tabs, setTabs] = useState<string>("0")

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])

    const [openDialog, setOpenDialog] = useState<boolean>(false)

    const [dialogMode, setDialogMode] = useState<'add' | 'edit'>('add')
    const [selectedData, setSelectedData] = useState<any>(null)


    useEffect(() => {
        getData(tabs)
    }, [])

    const navigate = useNavigate();

    const getData = (mode: any) => {
        setListData([])
        let url = apiUrl.apiUrl + '/acc/dp-customer/list'

        axios
            .get(url, {
                params: {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir,
                    mode: mode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getDetail = (id: any) => {

        let url = apiUrl.apiUrl + '/acc/dp-customer/detail/' + id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    setDialogMode('edit')
                    setSelectedData(data)
                    setOpenDialog(true)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/acc/dp-customer/delete-dp/' + row.id
        axios
            .post(url, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getData(tabs)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row)
            },
            {
                title: "Print",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/acc/dp-customer/pdf/' + row.id, '_blank')
            },
            {
                title: "Hapus",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(row: any) => {
                        getDetail(row.id)
                    }}
                />
            ),
        },
    ];

    const hiddenColumns = ['id', 'jenis_dokumen', 'doc_type', 'doc_id', 'is_bg', 'is_aktif', 'sysdoctag_id']

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='DP CUSTOMER' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab
                                color='primary'
                                size='medium'
                                onClick={() => {
                                    setDialogMode('add')
                                    setSelectedData(null)
                                    setOpenDialog(true)
                                }}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Semua DP' />
                            <Tab value='1' label='DP Belum Terlunasi' />
                            <Tab value='2' label='DP Belum Digunakan' />
                        </TabList>
                        <TabPanel value='0'>
                            <Grid
                                item
                                container
                                sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                                spacing={5}
                            >
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Tanggal Awal'
                                            type='date'
                                            onChange={(e) => setTglAwal(e.target.value)}
                                            value={tglAwal}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>

                                        <TextField
                                            label='Tanggal Akhir'
                                            type='date'
                                            onChange={(e) => setTglAkhir(e.target.value)}
                                            value={tglAkhir}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <FormControl fullWidth>
                                        <Button
                                            variant='contained'
                                            sx={{ mt: 1 }}
                                            startIcon={<Icon icon='mdi:magnify' />}
                                            onClick={() => getData(tabs)}
                                        >
                                            Cari Data
                                        </Button>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <MsiDatagrid array={listData} actions={actionData} hiddenColumns={hiddenColumns} />
                        </TabPanel>
                        <TabPanel value='1'>
                            <MsiDatagrid array={listData} actions={actionData} hiddenColumns={hiddenColumns} />
                        </TabPanel>
                        <TabPanel value='2'>
                            <MsiDatagrid array={listData} actions={actionData} hiddenColumns={hiddenColumns} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>

            <DialogDP
                key={selectedData?.id ?? 'add'}
                open={openDialog}
                mode={dialogMode}
                data={selectedData}
                onClose={() => {
                    setOpenDialog(false)
                    getData(tabs)
                }}
            />

        </Grid>
    )
}
